import * as React from 'react';
import { useParams, useHistory } from 'react-router-dom';
// import Data from '../components/Data';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { motion } from 'framer-motion';
import { carAnimation } from '../components/Animations';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

// import useable thing from firebase
import { collection, onSnapshot, orderBy, query } from '@firebase/firestore';
import { db } from '../config/firebaseConfig';
import Grid from '@mui/material/Grid';

const Car = () => {
  const [data, setData] = React.useState([]);
  const [newData, setNewData] = React.useState([]);

  // get id from url
  const { id } = useParams();
  const history = useHistory();

  //   get single car from Database
  React.useEffect(() => {
    const newData = data?.filter((data) => data.id === id);
    setNewData(newData);
  }, [data, id]);

  // get data from firebase and set it to data
  React.useEffect(
    () =>
      onSnapshot(
        query(collection(db, 'carPost'), orderBy('timestamp', 'desc')),
        (snapshot) => {
          setData(
            snapshot.docs?.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            })
          );
        }
      ),
    []
  );

  return (
    <>
      {newData.length > 0 && (
        <div className="carContainer">
          <motion.div
            className="car"
            variants={carAnimation}
            animate="show"
            exit="hide"
          >
            <div className="navigateBack" onClick={() => history.goBack()}>
              <ArrowBackIcon />
            </div>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={8} lg={8}>
                <Carousel autoPlay infiniteLoop showStatus={false}>
                  {newData[0]?.featureLink?.map((el) => (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '391px',
                      }}
                    >
                      <img
                        src={el}
                        alt="single car"
                        style={{
                          height: '100%',
                          width: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  ))}
                </Carousel>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                style={{
                  background: 'tomato 30%',
                }}
              >
                <div className="carText">
                  <h3>
                    {newData[0]?.brand}{' '}
                    <span
                      style={{
                        fontWeight: 'bold',
                        color: '#fff',
                        fontSize: '18px',
                      }}
                    >
                      {newData[0]?.model}
                    </span>
                  </h3>

                  <p>{newData[0]?.description}</p>

                  <ul className="car-details">
                    <li>Price - ${newData[0]?.price}</li>
                    <li>Engine - {newData[0]?.engine}</li>
                    <li>Fuel-type - {newData[0]?.fuelType}</li>
                    <li>Gasoline - {newData[0]?.gasoline}</li>
                    <li>Mileage - {newData[0]?.mileage}CC</li>
                    <li>Transmission - {newData[0]?.transmission}</li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default Car;
